export const toggleModal = "toggleModal"
export const ADD_ACTIVITY_LOG_TO_LIST = "ADD_ACTIVITY_LOG_TO_LIST"




